import React from 'react';
// import { Building, Users } from '@saleshandy/icons';
// import SearchingEmptyImage from '../../../../shared/components/images/searching-empty-image';
import AiSearchBar from '../ai-search-bar/ai-search-bar';
import GroupSearch from '../../../../shared/components/images/group-search';
import ApplySearch from '../../../../shared/components/images/apply-search';
import ExternalLinkBlue from '../../../../shared/components/images/external-link-blue';
import {
  getUserRole,
  isWhiteLabel,
} from '../../../../shared/utils/user-details';

export default function SearchingEmpty() {
  return (
    <>
      <div className="searching-empty">
        <div style={{ width: '646px', marginBottom: '24px' }}>
          <AiSearchBar />
        </div>
        {/* <SearchingEmptyImage /> */}
        <div className="searching-empty-container">
          <h3>Get leads from 700M+ contacts across 60M+ companies</h3>
          {/* <p className="regular-2 text-desc">
          Effortlessly uncover verified email addresses and phone numbers for
          your key leads <br /> using our search-by-name, keyword, or filter
          features.
        </p> */}
          <div className="leads-profile">
            <div className="professional-profile">
              {/* <Users className="profile-icon" /> */}
              <GroupSearch />
              <p className="profile-lable">Start typing query</p>
              <p className="profile-text">
                Search by job title, location, or industry.
              </p>
            </div>
            <div className="professional-profile">
              {/* <Building className="profile-icon" /> */}
              <ApplySearch />
              <p className="profile-lable">Apply search filters</p>
              <p className="profile-text">
                Use filters from the beginning to get more accurate search
                results.
              </p>
            </div>
          </div>
          {!isWhiteLabel() ||
            (getUserRole() !== 'client-restricted-access' && (
              <p className="searching-empty-footer">
                If you're looking to capture leads straight from LinkedIn, then{' '}
                <a
                  href={process.env.REACT_APP_SALESHANDY_CHROME_EXTENSION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Chrome Extension
                  <ExternalLinkBlue />
                </a>
              </p>
            ))}
        </div>
      </div>
    </>
  );
}
